import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import EmailTemplatesGridLayout from './containers/Grid'

export default function EmailTemplateLayout() {
  return <Router>
    <PrivateRoute path="/settings/email-templates" component={EmailTemplatesGridLayout} />
  </Router>;
}
